export type PlannedOutreach = {
  id: string;
  title: string;
  /** Rough timing label, e.g. "July 2028" */
  when: string;
};

/**
 * Planned outreaches not yet in the events DB (or not open for signup).
 * Open-for-signup items come from published upcoming events in Supabase.
 */
export const PLANNED_OUTREACHES: PlannedOutreach[] = [
  {
    id: 'summer-games',
    title: 'Summer Games Outreach',
    when: 'July 2028',
  },
  {
    id: 'winter-games',
    title: 'Winter Games Outreach',
    when: 'February 2030',
  },
];
